<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <bill-reviewer
      ref="billReviewer"
      @deleteBill="deleteBill"
      @reloadList="getBillList"
    />
    <new-bill-add
      ref="newBillAdd"
      :isActive="addNewDataSidebar"
      @close="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-table
      id="billListContent"
      ref="table"
      :data="bills"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni Fatura" position="top">
                    <vs-button
                      @click="addNewData"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip title="Excel Export" position="top">
                    <vs-button
                      @click="getExcelBill"
                      color="transparent"
                      type="gradient"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      icon-pack="feather"
                      icon="icon-download"
                    />
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <vs-col
            vs-type="flex"
            vs-w="12"
            vs-justify="center"
            vs-align="center"
          >
            <div class="btn-group">
              <vs-button
                @click="billStatusSelection = false"
                type="line"
                class="mr-1 billText"
                :class="{
                  'clicked-line-button bold text-primary weight-600 ':
                    !billStatusSelection,
                  'text-dark': billStatusSelection,
                }"
              >
                Bekleyen Faturalar</vs-button
              >
              <vs-button
                @click="billStatusSelection = true"
                type="line"
                class="ml-1 billText"
                :class="{
                  'clicked-line-button bold text-primary weight-600 ':
                    billStatusSelection,
                  'text-dark': !billStatusSelection,
                }"
              >
                Tamamlanan Faturalar</vs-button
              >
            </div>
          </vs-col>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'billNo' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('billNo')"
            >No
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12" v-if="$isCenterBranch()">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'branch.Name' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('branch.Name')"
            >Şube
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('created')"
            >Tarih
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            color="primary"
            type="flat"
            >Saat
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'supplier.Name' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('supplier.Name')"
            >Tedarikçi
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'paymentMethod.Name'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('paymentMethod.Name')"
            >Ödeme
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'totalPrice' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('totalPrice')"
            >Tutar
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'leftPrice' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('leftPrice')"
            >Kalan Tutar
          </vs-button>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.id }}</p>
            </vs-td>
            <vs-td class="w-1/12" v-if="$isCenterBranch() || $isRegionalCenterBranch()">
              <p class="text-center">{{ tr.branch.name }}</p>
            </vs-td>
            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.date }}</p>
            </vs-td>
            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.time }}</p>
            </vs-td>
            <vs-td class="w-2/12">
              <p class="text-center" v-if="tr.supplier != null">
                {{
                  tr.supplier.name +
                  (tr.distributor != null ? " - " + tr.distributor.name : "")
                }}
              </p>
            </vs-td>
            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.paymentMethod.name }}</p>
            </vs-td>
            <vs-td class="w-2/12">
              <p class="text-center">{{ $toCurrency(tr.totalPrice, 2) }}</p>
            </vs-td>
            <vs-td class="w-2/12">
              <p
                class="text-center m-auto"
                style="width: fit-content"
                v-if="tr.status == 1"
              >
                <vs-chip color="primary">
                  {{ $toCurrency(Math.max(0, tr.leftPrice), 2) }}
                </vs-chip>
              </p>
              <feather-icon
                v-else
                icon="CheckIcon"
                svgClasses="h-5 w-5 text-success"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import BillReviewer from "./BillReviewer.vue";
import GlobalFilter from "../GlobalFilter";
import PaginationDefault from "../PaginationDefault";
import NewBillAdd from "./NewBillAdd.vue";
import moduleBill from "@/store/bill/moduleBill.js";
import { getExcelList } from "@/api/Bill.js";
/* eslint-disable */
export default {
  components: {
    NewBillAdd,
    PaginationDefault,
    BillReviewer,
    GlobalFilter,
  },
  data() {
    return {
      selected: "",
      billStatusSelection: false,

      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      addNewDataSidebar: false,
      sidebarData: {},

      tableOptions: {},
      isFilterActive: false,
      filterOptions: [
        "branch",
        "dateRange",
        "timeRange",
        "supplier",
        "distributor",
        "stock",
        "stockCode",
        "billNo",
        "paymentMethod",
        "price",
      ],
      filterOptionNames: [
        "Şube",
        "Tarih",
        "Saat",
        "Tedarikçi",
        "Distributor",
        "Stok Adı",
        "Stok Kodu",
        "Fatura No",
        "Ödeme",
        "Tutar",
      ],
      filterChips: [],
    };
  },
  computed: {
    bills() {
      if (!this.billStatusSelection)
        return this.$store.state.bill.inCompleteBills;
      else return this.$store.state.bill.completeBills;
    },
    totalDataRow() {
      if (!this.billStatusSelection)
        return this.$store.state.bill.inCompleteBillsTotal;
      else return this.$store.state.bill.completeBillsTotal;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    getExcelBill() {

      getExcelList(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Faturalar" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    deleteBill(id) {
      this.$store.dispatch("bill/removeBill", id).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: error,
        });
      });
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branch: null,
        billNo: null,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        price: {
          min: null,
          max: null,
        },
        distributor: null,
        supplier: null,
        paymentMethod: null,
        stock: null,
        stockCode: null,
        status: null,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    addNewData() {
      this.sidebarData = {};
      if (!this.$isCenterBranch())
        this.$refs.newBillAdd.selectedBranch = this.$currentUser.branch;
      this.toggleDataSidebar(true);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    getBillList() {
      if (this.$isRegionalCenterBranch()) {
        this.$store
        .dispatch("bill/fetchDataListItemsBillForDealer", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      } else {
        this.$store
        .dispatch("bill/fetchDataListItemsBill", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      }
      
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  created: async function () {
    if (!moduleBill.isRegistered) {
      this.$store.registerModule("bill", moduleBill);
      moduleBill.isRegistered = true;
    }
    this.clearFilter();
    // if (!this.$isCenterBranch()) {
    //   let branchPropIndex = this.filterOptions.indexOf("branch");
    //   this.filterOptions.splice(branchPropIndex, 1);
    //   this.filterOptionNames.splice(branchPropIndex, 1);

    //   delete this.tableOptions["branch"];
    // }
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.getBillList();
      },
    },
    selected(val) {
      if (val != "") {
        this.$refs.billReviewer.theBill = val;
        this.$refs.billReviewer.isActive = true;
        this.selected = "";
      }
    },
    currentPage: function () {
      this.tableOptions.pageIndex = this.currentPage;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
};
</script>

<style>
#billListContent .vs-con-tbody {
  max-height: calc(100vh - 230px);
  overflow-y: auto;
}

.clicked-line-button .vs-button--linex {
  width: 100% !important;
}
</style>
